<template>
  <div class="col-l-12 col-m-12 col-12">
    <FormInput dataField="Song Name" placeHolder="Name of the song being registered" v-model="songRegistration.songTitle" />
    <EnumInput data-field="Work Content" place-holder="WorkContent" :items="WorkContentOptions" v-model="songRegistration.workContent" />
    <FormInput dataField="Language" placeHolder="Language of the song being registered" v-model="songRegistration.songLanguage" />
    <FormInput dataField="ISWC" placeHolder="ISWC of the song being registered" v-model="songRegistration.ISWC" />
    <FormInput dataField="Alt Title" placeHolder="Alternative Title of the song being registered" v-model="songRegistration.altTitle" />
  </div>
</template>
<script setup>
  import FormInput from '@/components/felements/FormInput.vue';
  import EnumInput from '@/components/felements/EnumInput.vue'
  import { WorkContentOptions } from '@/models/SongRegistration.ts'; 
  import { defineModel } from 'vue';
  const songRegistration = defineModel('songRegistration')
  
</script>